import { defineMessages } from 'react-intl';

const messages = defineMessages({
  header: {
    defaultMessage: 'Packing Slips',
    description: 'Packing slips page header',
    id: 'q+R+ky',
  },
  pageSummary: {
    defaultMessage:
      'Need to have a custom packing slip for each of your stores? Or maybe you have fragile items that need additional instructions? You can set-up your customized packing slips here.',
    id: 'JU9518',
    description: 'summary of why this page is used',
  },
  tableHeaderPackingSlips: {
    defaultMessage: 'All Packing Slips',
    id: 'gCnWq+',
    description: 'table header for the packing slips',
  },
  fourBySixSizeValue: {
    defaultMessage: '4"x6"',
    id: 'uvuKSz',
    description: '4 inch by 6 inch packing slip size value in table',
  },
  eightByElevenSizeValue: {
    defaultMessage: '8.5"x11"',
    id: 'qqIWPD',
    description: '8.5 inch by 11 inch packing slip size value in table',
  },
  a4SizeValue: {
    defaultMessage: 'A4',
    id: 'cEILC0',
    description: 'A4 packing slip size value in table',
  },
  a6SizeValue: {
    defaultMessage: 'A6',
    id: 'voAvkx',
    description: 'A6 packing slip size value in table',
  },
  createNewTemplate: {
    defaultMessage: 'New Template',
    id: 'GlcQja',
    description: 'button text to create new packing slip template',
  },
  gridColName: {
    defaultMessage: 'Name',
    id: 'LhHGdH',
    description: 'grid column header for the user-defined name of the item',
  },
  gridColSize: {
    defaultMessage: 'Size',
    id: '31uqaF',
    description: 'grid column header for the user-defined size of the format',
  },
  gridColCreated: {
    defaultMessage: 'Created',
    id: 'T1VoGJ',
    description: 'grid column header for the created on date',
  },
  gridColLastModified: {
    defaultMessage: 'Last Modified By',
    id: 'f2S6nV',
    description: 'grid column header for the user who last modified',
  },
  gridColLastModifiedDate: {
    defaultMessage: 'Last Modified',
    id: 'LVSQAB',
    description: 'grid column header for the last modified on date',
  },
  gridColActions: {
    defaultMessage: 'Actions',
    id: 'ePWybz',
    description: 'grid colum header for available actions on',
  },
  apiFetchError: {
    defaultMessage: 'An error occurred fetching packing slip templates',
    id: 'u2GFJJ',
    description: 'message to show the user if an api error occurs',
  },
  apiSaveError: {
    defaultMessage: 'An error occurred saving the data',
    id: 'gGAT5M',
    description: 'error message to show the user if an api error occurs',
  },
  apiDeleteError: {
    defaultMessage: 'An error occurred deleting the packing slip',
    id: 'tmu5rq',
    description: 'error message for if delete fails',
  },
  modalHeaderCreate: {
    defaultMessage: 'New Packing Slip Template',
    id: '7dgWnv',
    description: 'title for the packing slip template modal',
  },
  modalHeaderUpdate: {
    defaultMessage: 'Update Packing Slip Template',
    id: 'VoSOgn',
    description: 'title for the packing slip template modal',
  },
  name: {
    defaultMessage: 'Name',
    id: 'zGbn8B',
    description: 'name of the packing slip',
  },
  selectSizeLabel: {
    defaultMessage: 'Select Size',
    id: 'SCIkt+',
    description: 'dropdown select label to choose the size of the packing slip template',
  },
  save: {
    defaultMessage: 'Save',
    id: 'ye4ha2',
    description: 'save changes',
  },
  delete: {
    defaultMessage: 'Delete',
    id: 'PuZFhw',
    description: 'delete packing slip permanently',
  },
  askToDelete: {
    defaultMessage: 'Are you sure you want to delete the following packing slip?',
    id: '7inqbV',
    description: 'ask the user to confirm the deletion',
  },
  cancel: {
    defaultMessage: 'Cancel',
    id: 'hFPEGR',
    description: 'discard changes',
  },
  editorHeaderTitle: {
    defaultMessage:
      '<b>Order Header</b> - Top section of the packing slip. Typically includes store branding, recipient address, and order details.',
    id: 'TCg6EB',
    description: 'section title for the header',
  },
  editorItemsHeaderTitle: {
    defaultMessage: '<b>Order Items Header</b> - Column headers for the items table. Define labels like SKU, Quantity, Description, etc.',
    id: 'mAw8ow',
    description: 'section title for the items header',
  },
  editorItemsTitle: {
    defaultMessage:
      '<b>Order Items</b> - Template for each line item in the order. This section repeats for every product in the shipment.',
    id: 'PY4sFh',
    description: 'section title for the items',
  },
  editorFooterTitle: {
    defaultMessage:
      '<b>Order Footer</b> - Bottom section of the packing slip. Often includes totals, thank you messages, or return instructions.',
    id: 'C4wMrx',
    description: 'section title for the footer',
  },
  editAction: {
    defaultMessage: 'Edit',
    id: 'frEkp6',
    description: 'option to edit an existing template',
  },
  deleteAction: {
    defaultMessage: 'Delete',
    id: 'YNtIen',
    description: 'option to delete an existing template',
  },
  copyAction: {
    defaultMessage: 'Copy',
    id: 'ukdWJQ',
    description: 'option to create a copy of an existing template',
  },
  templateActionsMenu: {
    defaultMessage: 'Template actions',
    id: 'RKfSi4',
    description: 'aria-label for template actions menu button',
  },
  downloadAction: {
    defaultMessage: 'Download',
    id: 'K2uAFe',
    description: 'option to download a sample of the chosen template',
  },
  downloadSample: {
    defaultMessage: 'Download Sample',
    id: 'AmpHwy',
    description: 'button text to choose a template to download',
  },
  startingDownload: {
    defaultMessage: 'Starting Download...',
    id: 'ow4iWl',
    description: 'notification to let the user know a download has started',
  },
  finishedDownload: {
    defaultMessage: 'Download complete!',
    id: 'ifQexO',
    description: 'notification to let the user know a download has finished',
  },
  deleteConfirmationTitle: {
    defaultMessage: 'Delete Packing Slip',
    id: 'HQc2VA',
    description: 'title for delete template confirmation modal',
  },
  copySuffix: {
    defaultMessage: '{name} Copy',
    id: '1/FIwh',
    description: 'appended to template name after copy action is used',
  },
  createNewHtmlTemplate: {
    defaultMessage: 'Create a new template',
    id: 'ONs/+L',
    description: 'button text to create a new HTML-based packing slip template',
  },
  htmlEditorTitle: {
    defaultMessage: 'Packing Slip Editor',
    id: 'uKaA8f',
    description: 'title for the HTML packing slip editor drawer',
  },
  aiGeneratedBanner: {
    defaultMessage: 'This template was generated by Ask ShipStation. Review the content and click Save to keep it.',
    id: '0E2C7d',
    description: 'Banner message shown when a packing slip template was generated by Ask ShipStation AI',
  },
  previewTab: {
    defaultMessage: 'Preview',
    id: 'Q7EQsA',
    description: 'Tab label for the packing slip template preview',
  },
  codeTab: {
    defaultMessage: 'Code',
    id: 'I84WQb',
    description: 'Tab label for the packing slip template code editor',
  },
  gridColStoreDefaults: {
    defaultMessage: 'Store Defaults',
    id: 'Q/2Xqc',
    description: 'grid column header for stores that use this template as their default packing slip',
  },
  storesCount: {
    defaultMessage: '{count, plural, one {# store} other {# stores}}',
    id: 'TE2V/a',
    description: 'summary count of stores using this packing slip template as default',
  },
  storeDefaultsTitle: {
    defaultMessage: 'Store Defaults',
    id: 'Js5afx',
    description: 'title for the popover listing stores that use this packing slip template as default',
  },
});

export default messages;
